import Joi from 'joi-browser';
import { parseJoiMessages, SpanishJoi } from './joi';

export default (schema, validateOnPublish) => (data) => {
  if (
    validateOnPublish && (
      {}.hasOwnProperty.call(data, 'publish') === false
      || !data.publish
    )
  ) {
    return {};
  }

  const { error } = Joi.validate(data, schema, {
    abortEarly: false,
    stripUnknown: true,
    language: SpanishJoi,
  });

  if (error) {
    return parseJoiMessages(error.details);
  }
  return {};
};



// WEBPACK FOOTER //
// ./src/utils/ValidatesFormWith.js